/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { CreateThemeRequest } from '../models';
// @ts-ignore
import { ThemesResponse } from '../models';
/**
 * ThemesApi - axios parameter creator
 * @export
 */
export const ThemesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Theme
         * @param {string} gamixAppId 
         * @param {CreateThemeRequest} createThemeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        themesControllerCreate: async (gamixAppId: string, createThemeRequest: CreateThemeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('themesControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'createThemeRequest' is not null or undefined
            assertParamExists('themesControllerCreate', 'createThemeRequest', createThemeRequest)
            const localVarPath = `/v2/themes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createThemeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Theme
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        themesControllerDelete: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('themesControllerDelete', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('themesControllerDelete', 'id', id)
            const localVarPath = `/v2/themes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Theme
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        themesControllerGet: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('themesControllerGet', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('themesControllerGet', 'id', id)
            const localVarPath = `/v2/themes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Theme By App
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        themesControllerGetByApp: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('themesControllerGetByApp', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/themes/app`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Theme
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {CreateThemeRequest} createThemeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        themesControllerUpdate: async (gamixAppId: string, id: string, createThemeRequest: CreateThemeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('themesControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('themesControllerUpdate', 'id', id)
            // verify required parameter 'createThemeRequest' is not null or undefined
            assertParamExists('themesControllerUpdate', 'createThemeRequest', createThemeRequest)
            const localVarPath = `/v2/themes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createThemeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThemesApi - functional programming interface
 * @export
 */
export const ThemesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ThemesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Theme
         * @param {string} gamixAppId 
         * @param {CreateThemeRequest} createThemeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async themesControllerCreate(gamixAppId: string, createThemeRequest: CreateThemeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThemesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.themesControllerCreate(gamixAppId, createThemeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThemesApi.themesControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Theme
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async themesControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.themesControllerDelete(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThemesApi.themesControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Theme
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async themesControllerGet(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThemesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.themesControllerGet(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThemesApi.themesControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Theme By App
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async themesControllerGetByApp(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThemesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.themesControllerGetByApp(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThemesApi.themesControllerGetByApp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Theme
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {CreateThemeRequest} createThemeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async themesControllerUpdate(gamixAppId: string, id: string, createThemeRequest: CreateThemeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThemesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.themesControllerUpdate(gamixAppId, id, createThemeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThemesApi.themesControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ThemesApi - factory interface
 * @export
 */
export const ThemesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ThemesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Theme
         * @param {ThemesApiThemesControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        themesControllerCreate(requestParameters: ThemesApiThemesControllerCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ThemesResponse> {
            return localVarFp.themesControllerCreate(requestParameters.gamixAppId, requestParameters.createThemeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Theme
         * @param {ThemesApiThemesControllerDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        themesControllerDelete(requestParameters: ThemesApiThemesControllerDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.themesControllerDelete(requestParameters.gamixAppId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Theme
         * @param {ThemesApiThemesControllerGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        themesControllerGet(requestParameters: ThemesApiThemesControllerGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ThemesResponse> {
            return localVarFp.themesControllerGet(requestParameters.gamixAppId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Theme By App
         * @param {ThemesApiThemesControllerGetByAppRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        themesControllerGetByApp(requestParameters: ThemesApiThemesControllerGetByAppRequest, options?: RawAxiosRequestConfig): AxiosPromise<ThemesResponse> {
            return localVarFp.themesControllerGetByApp(requestParameters.gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Theme
         * @param {ThemesApiThemesControllerUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        themesControllerUpdate(requestParameters: ThemesApiThemesControllerUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ThemesResponse> {
            return localVarFp.themesControllerUpdate(requestParameters.gamixAppId, requestParameters.id, requestParameters.createThemeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for themesControllerCreate operation in ThemesApi.
 * @export
 * @interface ThemesApiThemesControllerCreateRequest
 */
export interface ThemesApiThemesControllerCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ThemesApiThemesControllerCreate
     */
    readonly gamixAppId: string

    /**
     * 
     * @type {CreateThemeRequest}
     * @memberof ThemesApiThemesControllerCreate
     */
    readonly createThemeRequest: CreateThemeRequest
}

/**
 * Request parameters for themesControllerDelete operation in ThemesApi.
 * @export
 * @interface ThemesApiThemesControllerDeleteRequest
 */
export interface ThemesApiThemesControllerDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ThemesApiThemesControllerDelete
     */
    readonly gamixAppId: string

    /**
     * 
     * @type {string}
     * @memberof ThemesApiThemesControllerDelete
     */
    readonly id: string
}

/**
 * Request parameters for themesControllerGet operation in ThemesApi.
 * @export
 * @interface ThemesApiThemesControllerGetRequest
 */
export interface ThemesApiThemesControllerGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ThemesApiThemesControllerGet
     */
    readonly gamixAppId: string

    /**
     * 
     * @type {string}
     * @memberof ThemesApiThemesControllerGet
     */
    readonly id: string
}

/**
 * Request parameters for themesControllerGetByApp operation in ThemesApi.
 * @export
 * @interface ThemesApiThemesControllerGetByAppRequest
 */
export interface ThemesApiThemesControllerGetByAppRequest {
    /**
     * 
     * @type {string}
     * @memberof ThemesApiThemesControllerGetByApp
     */
    readonly gamixAppId: string
}

/**
 * Request parameters for themesControllerUpdate operation in ThemesApi.
 * @export
 * @interface ThemesApiThemesControllerUpdateRequest
 */
export interface ThemesApiThemesControllerUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ThemesApiThemesControllerUpdate
     */
    readonly gamixAppId: string

    /**
     * 
     * @type {string}
     * @memberof ThemesApiThemesControllerUpdate
     */
    readonly id: string

    /**
     * 
     * @type {CreateThemeRequest}
     * @memberof ThemesApiThemesControllerUpdate
     */
    readonly createThemeRequest: CreateThemeRequest
}

/**
 * ThemesApi - object-oriented interface
 * @export
 * @class ThemesApi
 * @extends {BaseAPI}
 */
export class ThemesApi extends BaseAPI {
    /**
     * 
     * @summary Create Theme
     * @param {ThemesApiThemesControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThemesApi
     */
    public themesControllerCreate(requestParameters: ThemesApiThemesControllerCreateRequest, options?: RawAxiosRequestConfig) {
        return ThemesApiFp(this.configuration).themesControllerCreate(requestParameters.gamixAppId, requestParameters.createThemeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Theme
     * @param {ThemesApiThemesControllerDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThemesApi
     */
    public themesControllerDelete(requestParameters: ThemesApiThemesControllerDeleteRequest, options?: RawAxiosRequestConfig) {
        return ThemesApiFp(this.configuration).themesControllerDelete(requestParameters.gamixAppId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Theme
     * @param {ThemesApiThemesControllerGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThemesApi
     */
    public themesControllerGet(requestParameters: ThemesApiThemesControllerGetRequest, options?: RawAxiosRequestConfig) {
        return ThemesApiFp(this.configuration).themesControllerGet(requestParameters.gamixAppId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Theme By App
     * @param {ThemesApiThemesControllerGetByAppRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThemesApi
     */
    public themesControllerGetByApp(requestParameters: ThemesApiThemesControllerGetByAppRequest, options?: RawAxiosRequestConfig) {
        return ThemesApiFp(this.configuration).themesControllerGetByApp(requestParameters.gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Theme
     * @param {ThemesApiThemesControllerUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThemesApi
     */
    public themesControllerUpdate(requestParameters: ThemesApiThemesControllerUpdateRequest, options?: RawAxiosRequestConfig) {
        return ThemesApiFp(this.configuration).themesControllerUpdate(requestParameters.gamixAppId, requestParameters.id, requestParameters.createThemeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

